import './job-offers.scss';

jQuery('document').ready(function () {
  jQuery(document).on('submit', '.webform-submission-job-offer-application-form', function (e) {
    var currentJob = jQuery('#edit-job-offers').val();
    var eventActionValue = 'Candidature spontanée';

    if(currentJob > 0) {
      eventActionValue = 'Poste affiché';
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': 'Carrières',
      'eventAction': eventActionValue,
      'eventLabel': 'Soumission formulaire candidature'
    });
  });
});
